import WidgetBase from '@dojo/widget-core/WidgetBase';
import { WNode } from '@dojo/widget-core/interfaces';
import { DNode } from '@dojo/widget-core/interfaces';
import { v, w } from '@dojo/widget-core/d';

import * as css from './styles/Ticker.m.css';
import ActionList from './ActionList';
import { API } from '../API';
// import { YousportAPI } from '../YousportAPI';
import GameTimeScoreWidget from './GameTimeScoreWidget';
import { ActionElementProperties, ActionListProperties } from './ActionList';
import { VideoListProperties, VideoElementProperties }  from './VideoList';
import GameInfo from './GameInfo';

const icon_calendar = require('./../img/calendar.png');
const icon_clock_b  = require('./../img/clock-blue.png');
const icon_reload   = require('./../img/reload.png');

export interface RefereeProperties {
    name: string | null,
    prename: string | null,
}

export interface ReportProperties {
    refereeA: RefereeProperties,
    refereeB: RefereeProperties,
}

export interface GameProperties {
    class_lname: string,
    guest_lname: string,
    home_lname: string,
    datetime: string,
    gym_name: string,
    gym_town: string,
    report: ReportProperties,
    status: number,
    status_description: string,
    
    id: number,
    
    loaded: boolean
}


export interface memberInfo {
    prename: string;
    name: string;
    player_no: string;
    person_id: number;
}

export interface team {
    club: string;
    team_members: memberInfo[];
}

export interface allGameInfoResult {
    team_home: team;
    team_guest: team;
    
}

export class Ticker extends WidgetBase {
    
    private game:GameProperties;
    private actions:ActionListProperties;
    private videos:VideoListProperties;
    public detailInfo: allGameInfoResult | null;

    private showDetails: boolean;
    private reloadCount: number;
    
    public home_score:string;
    public guest_score: string;
    public game_time:string;
    public gametimewidget:GameTimeScoreWidget;

    constructor() {
        super();
        this.game = {
            class_lname: "", guest_lname: "", home_lname: "", datetime: "__.__.____ __:__:__",
            gym_name: "", gym_town: "", report: {
                 refereeA: { name: "", prename: ""},
                 refereeB: { name: "", prename: ""},
            },
            status: 0, status_description: "",
            id: 0,
            loaded: false
        };
        this.showDetails = false;
        this.actions = { actionElements: [], loaded: false, isLastRefresh: false };
        this.videos = { videoElements: [], loaded: false, };
        this.reloadCount = 10;
        this.loadActions();
        this.loadGameInfo();
        this.loadDetailInfo();
    }
    
	protected render() {
        
        // console.log("Ticker#render");
        
        if (!this.game.datetime) {
            return v('div', { key: "loaderror", classes: [ css.reloadbutton ], }, [ 'Error loading game' ]);
        }
        
        if (!this.actions || !this.actions.loaded || !this.game || !this.game.loaded) {
            return v('div', { key: "loadinfo", classes: [ css.reloadbutton ], }, [ 'Loading game scores' ]);
        }
        // create these first, because creating gametimescore sets our 
        // gametimewidget (bah!), and creating the actionlist sets time and score
        // into the gametimewidget.

        // console.log("ticker render with action = ", this.actions);

        var gametimescore:WNode=w(GameTimeScoreWidget, {parent: this});
        var actionlist: WNode = w(ActionList, {parent: this, actions: this.actions, videos: this.videos});
        var body:DNode[] = [];

        if (!this.showDetails) {
            // Ticker-Data - game actions
            // optional reload button at top

            if (this.actions.isLastRefresh) {
                body[0] =                 v('div',        { classes: [css.reloadcontainer], key: 'reloadReminder' }, [
                    v('div', {classes: [css.reloadbutton], onclick: this.reloadDocument }, [
                        v('img', { src: icon_reload, classes: [css.reloadimage] }),
                        v('div', { classes: [ css.reloadtext ]}, [
                            v('div', {}, ["Bitte laden Sie die Seite neu,"]),
                            v('div', {}, ["um neue Ergebnisse zu sehen"]),
                        ])
                    ])
                ])

            }
            
            // ticker header
            body[1]=
                v('div',            { key: 'tickertabhead', classes: [ css.box, css.tabhead ] }, [
                    // v('div',        { classes: [ css.tabheadcell, css.time       ] },   [ "Spielzeit" ]),
                    v('div',        { classes: [ css.tabheadcell, css.actiontext, css.hideifsmall  ] },   [ "Aktion" ]),
                    v('div',        { classes: [ css.tabheadcell, css.actiontext, css.hideifwide   ] },   [ "Aktion" ]),
                    v('div',        { classes: [ css.tabheadcell, css.actionicon ] },   [ "" ]),
                    v('div',        { classes: [ css.tabheadcell, css.restimehead ] },   [ "Spielstand" ]),
                    v('div',        { classes: [ css.tabheadcell, css.actionicon ] },   [ "" ]),
                    v('div',        { classes: [ css.tabheadcell, css.actiontext, css.hideifsmall ] },   [ "Aktion" ]),
                    // v('div',        { classes: [ css.tabheadcell, css.time, css.hideifsmall       ] },   [ "" ]),
                ]);

           // ticker content     
            body[2]=actionlist;
        } else {
            // detail info only (teams, player list, goals, warnings, ...)
            body[0] = w(GameInfo, {parent: this, actions: this.actions, detailInfo: this.detailInfo });
        }
        
        // everything around the page which is the same/similar for both display types
        return v('div', { key: "centering", classes: css.centerpage }, [
            v('div',     {key: "mainpage#" + this.showDetails, classes: css.root }, [
                // v('div',            { classes: css.advertisement }),
                v('div',            { classes: [ css.box, css.inforow ] }, [
                    v('div',        { classes: [ css.box ] },         [ this.userFriendlyTime() ]),
                    v('div',        { classes: [ css.box, css.league ] },           [ this.game.class_lname ]),
                    v('div',        { classes: [ css.linkbox ] }, [
                        // v('div',        { classes: [ css.box, css.link ] },             [ /* "Statistik" */]),
                        // v('div',        { classes: [ css.box, css.link ] },             [ /* "Video" */]),
                        v('div',        { classes: [ css.box, css.link ],
                                          onclick: this.toggleDetails },                [ this.showDetails ? "Spielverlauf" : "Aufstellung"]),
                    ]),
                ]),
                v('div',            { classes: [ css.box, css.inforow ] }, [
                    v('div',        { classes: [ css.box, css.club, css.left, this.showDetails ? css.clubbutton : null ],
                                        id: 'teambutton_left', onclick: this.switchTeamToHome },   [ this.game.home_lname ]),
                    gametimescore,
                    v('div',        { classes: [ css.box, css.club, css.right, this.showDetails ? css.clubbutton : null ],
                                        id: 'teambutton_right', onclick: this.switchTeamToGuest },  [ this.game.guest_lname ]),
                ]),
                
                body[0],
                body[1],
                body[2],
            ])
        ]);
	}
    
    protected userFriendlyTime() {
        return v('span', { classes: [ css.datetime ]}, [
            v('img', { classes: [ css.datetimeicon ], src: icon_calendar}),
            this.game.datetime.substr(8, 2)+"."+this.game.datetime.substr(5, 2),
            v('img', { classes: [ css.datetimeicon ], src: icon_clock_b}),
            this.game.datetime.substr(11,5)
        ]);
    }
    
    protected loadGameInfo() {
        new API().transactAsync("getGameInfo", this, this.gameLoaded);
    }
    
    protected gameLoaded(me: Ticker, gameInfo: GameProperties) {
        me.game = gameInfo;
        me.game.loaded = true;
        me.loadVideos(me.game.id);
        if (me.game && me.actions && me.game.loaded && me.actions.loaded) {
            me.invalidate();
        }
    }
    
    protected loadDetailInfo() {
        new API().transactAsync("getAllGameInfo", this, this.detailsLoaded);
    }
    
    protected detailsLoaded(me: Ticker, details: allGameInfoResult) {
        me.detailInfo = details;
        me.invalidate();
    }
 
    protected loadVideos(gameId: number) {
        // YouSport will keinen CORS Header setzen .. deshalb über unseren Server ...
        // new YousportAPI().transactAsync(gameId.toString(), this, this.videosLoaded);
        // Yousport ist tot, das hier fliegt raus. Damit sollte alles aussehen wie früher.
        // Lass den restlichen Code mal drin weil wer weiß was da noch irgendwann
        // wieder kommt ...
        
        /* new API().transactAsync("getVideos", this, this.videosLoaded); */
        this.videos = { videoElements: [], loaded: true, };
    }
    
    protected videosLoaded(me: Ticker, details: VideoElementProperties[]) {
        // create a new videos elements or the renderer won't rerender
        me.videos = { videoElements: details, loaded: true, };
        console.log("Videos are loaded");
        me.invalidate();
    }

    public setResultAndTime(home: string, guest: string, time: string) {
        this.home_score=home;
        this.guest_score=guest;
        this.game_time=time;
        this.gametimewidget.invalidate();
    }
    
    public toggleDetails() {
        this.showDetails = !this.showDetails;
        this.invalidate();
    }
    
    protected loadActions() {
        new API().transactAsync("getAllTickerMessages", this, this.actionsLoaded);
    }
    
    protected actionsLoaded(me: Ticker, elements: ActionElementProperties[]) {
        // Always create a new actions object or the renderer will assume it hasn't changed.
        me.actions = {actionElements: elements, loaded: true, isLastRefresh : true };
        me.reloadCount--;
        if (me.reloadCount > 0) {
            setTimeout(function() { new API().transactAsync("getAllTickerMessages", me, me.actionsLoaded)}, 15*1000);
            me.actions.isLastRefresh = false;
        } else {
            // console.log("last refresh");
        }
        if (me.game && me.game.loaded && me.actions.loaded) {
            me.invalidate();
        }
    }

    protected reloadDocument() {
        location.reload(true);
    }
    
    protected switchTeamToHome() { this.switchTeamTo('left', 'right'); }
    protected switchTeamToGuest() { this.switchTeamTo('right', 'left'); }
    
    protected switchTeamTo(visible: string, invisible: string) {
        if (window.innerWidth > 1200)
            return;
        var seen   = document.getElementById('teambox'+visible);
        var unseen = document.getElementById('teambox'+invisible);
        if (seen != null && unseen != null) {
            seen.style.display = 'inline-block';
            unseen.style.display = 'none';
            
            var elem;
            if ((elem=document.getElementById('teambutton_'+visible))!=null) {
                elem.style.backgroundColor='#ff6d00';
            }
            if ((elem=document.getElementById('teambutton_'+invisible))!=null) {
                elem.style.backgroundColor='#1e88e5';
            }
        }
    }
}

export default Ticker;



// WEBPACK FOOTER //
// ./node_modules/@dojo/webpack-contrib/css-module-dts-loader?type=ts&instanceName=0_dojo!./src/widgets/Ticker.ts